import script from "./login1.vue?vue&type=script&setup=true&lang=js"
export * from "./login1.vue?vue&type=script&setup=true&lang=js"

import "./login1.vue?vue&type=style&index=0&id=5972c4ea&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/fbdnextui_staging-uk-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5972c4ea"]])

export default __exports__